var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "trbo-a-powered-by" },
    [
      _vm._v("Powered "),
      _c("bot-icon", { staticClass: "trbo-a-powered-by__icon" }),
      _vm._v(" by\n  "),
      _vm.chatchampLinkClickable
        ? _c(
            "a",
            {
              staticClass: "trbo-a-powered-by__link",
              attrs: { href: _vm.link, target: "_blank" },
            },
            [_vm._v("trbo")]
          )
        : _c("span", [_vm._v("trbo")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }